import { Dialog, DialogProps } from '@mui/material';
import { PartnerPlatform } from '../../interfaces/PartnerPlatform/PartnerPlatform';
import { TrendyolSettings } from '../../pages/GeneralSettings/TabContent/TrendyolSettings';
import { HepsiburadaSettings } from '../../pages/GeneralSettings/TabContent/HepsiburadaSettings';
import { BoynerSettings } from '../../pages/GeneralSettings/TabContent/BoynerSettings';
import { N11Settings } from '../../pages/GeneralSettings/TabContent/N11Settings';
import { PazaramaSettings } from '../../pages/GeneralSettings/TabContent/PazaramaSettings';

type PartnerPlatformSettingsDialogProps = DialogProps & {
  partnerPlatform: PartnerPlatform;
  onSave: () => void;
};

export const PartnerPlatformSettingsDialog = ({
  partnerPlatform,
  onSave,
  ...props
}: PartnerPlatformSettingsDialogProps) => {
  const getContent = () => {
    switch (partnerPlatform) {
      case 'trendyol':
        return TrendyolSettings;
      case 'hepsiburada':
        return HepsiburadaSettings;
      case 'boyner':
        return BoynerSettings;
      case 'n11':
        return N11Settings;
      case 'pazarama':
        return PazaramaSettings;
      default:
        return null;
    }
  };

  const Content = getContent();

  return <Dialog {...props}>{!!Content && <Content onSave={onSave} />}</Dialog>;
};
